module.exports = __webpack_public_path__ + "img/logo.938f084e.png";